import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from '../../../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import { WidgetInput } from "react-addressfinder";
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
 import esim_image from '../../../../../../assets/images/esim.png';
import physical_image from '../../../../../../assets/images/physical.png';
import ActivationHead from './ActivationHead';
import Loader from "./loader";

const SERVER_URL = process.env.REACT_APP_API_URL+"wme-prepaid-activation/";
const isValidNo = /^[0-9]*$/;



const YourTelsimSim = ({nextStep, prevStep, commonSession, handleSession, handlePlanDetails, handleRetailer}) => {
    const validator = new SimpleReactValidator();
    const [physicalSim,setPhysicalSim]=useState(true)
    const[esim,setEsim]=useState(false)
    const[simType,setSimType]=useState("Physical Sim");


    const handleSimChange=(type)=>{
 
        if(type==="Physical Sim"){
            setPhysicalSim(true)
            setEsim(false)
            setSimType("Physical Sim")
        }else{
            setEsim(true)
            setPhysicalSim(false)
            setSimType("eSIM")
        }
    }
    

    
    const [state, setState] = useState({
        sim_number: '',
        loading: false,
        simerror: true
    });


   

    const simCheck = (event) => {
        if (event.target.value.match(isValidNo)) {
            setState((prevState) => ({ ...prevState, sim: event.target.value }));
        }
    };


    const mySubmitHandler = async (event) => {
        event.preventDefault();
        if(simType !== "eSIM" && !state.sim_number){
            swal("", "Please enter the sim number", 'warning');
            return;
        }
        setState((prevState) => ({ ...prevState, loading: true }));

        const post_data = {
            sim_number: state.sim_number,
            session_id: commonSession,
            sim_type  : simType
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}check`, post_data, { headers });
            var response_error = true;
            if(response.status===200){
                if(response.data.message !== 'undefined'){
                    //swal(response.data.message, "", 'success');
                    var response_error = false;
                    handleSession(response.data.data.SessionId);
                    handlePlanDetails(response.data.data);
                    if(response?.data?.data?.RetailerData){
                        handleRetailer(response.data.data.RetailerData);
                    }
                    nextStep();
                }
            }

            setState((prevState) => ({ ...prevState, loading: false }));
            if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }
            //nextStep();
        } catch (error) {
            setState((prevState) => ({ ...prevState, loading: false }));
            console.log(error);
            if(error.response.data.message != 'undefined'){
                swal("", error.response.data.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        const numericValue = value.replace(/[^0-9]/g, "");
        setState((prevState) => ({  sim_number: numericValue }));
    };


   
    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />

                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">
                        {state.loading === true && (
                            <Loader />
                        )}

                        <h6>Your Telsim SIM</h6>
                        <hr/>
                        <br/>

                        
                        <form onSubmit={mySubmitHandler} className="ad-mb-form choose-sim-block" autoComplete='off'>
                            
                            <div className="col-lg-6 choose-sim">
                                <label className="formbold-form-label formbold-form-label-2">Choose Sim Type</label>
                                <div className="simpik">
                                    <div className="simView simboxstyle" style={{border:simType === 'Physical Sim' && '1px solid #C11D6C'}} onClick={()=> handleSimChange("Physical Sim")}>
                                        <div style={{alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                                            <img src={physical_image} alt="image" style={{width: 40, height: 30}}/>
                                            <label className="col-xl-12 col-lg-12 col-form-label" style={{textAlign: 'center'}}>Physical SIM</label>
                                        </div>
                                    </div>

                                    <div className="esimView simView simboxstyle" style={{border:simType === 'eSIM' && '1px solid #C11D6C'}} onClick={()=> handleSimChange("eSIM")}>
                                        <div style={{alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                                            <img src={esim_image} alt="image" style={{width: 40, height: 30}}/>
                                            <label className="col-xl-12 col-lg-12 col-form-label" style={{textAlign: 'center'}}>eSIM</label>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {simType !== "eSIM" ?

                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 alignwithsimpik choose-sim">
                                    <label className="formbold-form-label formbold-form-label-2">Enter the SIM number on the Telsim SIM card <span className="madate_mark">*</span></label>
                                    <input
                                        type="text"
                                        name="sim_number"
                                        id="sim_number"
                                        maxLength="25"
                                        keyboardType="numeric"
                                        placeholder="Enter the SIM number on the Telsim SIM card"
                                        className="formbold-form-input"
                                        value={state.sim_number}
                                        onChange={handleChange}
                                        // required
                                    />
                                    
                                </div>
                                :
                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 alignwithsimpik choose-sim">
                                    <label className="formbold-form-label formbold-form-label-2" style={{ visibility:'hidden' }}>Click the "Confirm" button to continue.</label>
                                    <input
                                        type="text"
                                        name="sim_number"
                                        id="sim_number"
                                        placeholder="Click the 'Confirm' button to continue."
                                        className="formbold-form-input readonly"
                                        value=""
                                        readOnly
                                    />
                                    
                                </div>                           
                            }
                        
                   


                           <br/>
                           <br/>


                        
                            <br/>
                            <div className="button-container add-mb-button-container">


                                <button className="button btn btn-danger" style={{ visibility:'hidden'}}>
                                
                                </button>


                                <button className="button btn btn-danger ad-mb-button">
                                    {simType === "eSIM" ?
                                        <>
                                            Confirm
                                        </>
                                        :
                                        <>
                                            Verify to continue
                                        </>
                                    }
                                </button>
                            </div>


                        </form>

                    </div>

                    
                </div>
            </DashboardLayout>
        </div>
    );
};

export default YourTelsimSim;
